import { recordPath, recordRoute } from '@/shared/registry'

/** Where the lab pages live: Find Labs and Lab Details, Find Lab Series and Lab Series Details. */
export const labProfilesPath = '/catalog/labs'
export const labProfileRoute = recordRoute('catalog', 'labs')
export const labSeriesPath = '/catalog/lab-series'
export const labSeriesRoute = recordRoute('catalog', 'lab-series')

/** A lab profile's details page, by Lab on Demand's id. */
export function labProfilePath(id: number | string): string {
  return recordPath('catalog', 'labs', String(id))
}

/** A lab series' details page, by Lab on Demand's id. */
export function labSeriesDetailsPath(id: number | string): string {
  return recordPath('catalog', 'lab-series', String(id))
}

/** The base of Lab Details' and Lab Series Details' slots (`detailsSlots`). */
export const labProfileDetailsSlot = 'catalog.lab-profile-details'
export const labSeriesDetailsSlot = 'catalog.lab-series-details'
